import React from 'react'
import { VideoFragment } from '../src/model/fragments'
import { VideoArticle } from './VideoArticle'
import cn from 'classnames'

export interface VideoListProps {
	items: VideoFragment[]
	grid?: boolean
}

export const VideoList: React.FunctionComponent<VideoListProps> = (
	props,
) => {

	if(!props.items.length)
	{
		return <></>;
	}

	return (
		<div className={cn('videoList', props.grid ? 'videoList--grid' : '')}>
			{props.items.map((video) => (
				<div className="videoList-item" key={video.id}>
					<VideoArticle video={video} />
				</div>
			))}
		</div>
	)
}
